export const SALES_TEAM = {
  title: 'Sales Team',
  description: 'You can find here all the contact information needed to reach out to our sales team.',
  email: 'james@prerender.io',
  name: 'James Condon',
  picture: '/assets/img/james_condon.jpeg',
  bookMeetingURL: 'https://meetings-eu1.hubspot.com/james-condon',
};
